<template>
    <div class="page page--contact contact">
        <div class="cta">
            <div class="cta__content">
            </div>
        </div>
        <div class="page__content">
            <div class="page__content__block">
                <div>
                    <h1>{{$t('contact.title')}}</h1>
                </div>
                <div v-html="$t('contact.text')"></div>
            </div>
            <div class="page__content__block">
                <div class="contact__form">
                    <h2>{{$t('contact.form.title')}}</h2>
                    <form action="" id="contactform" method="post" @submit.prevent="checkForm" novalidate>

                        <div class="contact__form__half">
                            <label for="fname">{{$t('contact.form.firstname')}}</label>
                            <input id="fname" name="fname" type="text" class="input" v-model="formData.firstname">
                        </div>

                        <div class="contact__form__half">
                            <label for="name">{{$t('contact.form.lastname')}}</label>
                            <input id="name" name="name" type="text" class="input" v-model="formData.name">
                        </div>

                        <label for="email">{{$t('contact.form.email')}}</label>
                        <input id="email" name="email" type="email" class="input" v-model="formData.email">

                        <label for="subject">{{$t('contact.form.subject')}}</label>
                        <select name="subject" id="subject" v-model="formData.subject">
                            <option :value="item" v-for="item in categories" :key="`option--${item}`">
                                {{$t(`contact.form.subjects.${item}`)}}
                            </option>
                        </select>

                        <label for="message">{{$t('contact.form.message')}}</label>
                        <textarea name="message" id="message" cols="30" rows="10" v-model="formData.message"></textarea>

                        <div class="checkbox">
                            <input type="checkbox" id="gdpr" v-model="formData.gdpr"><label class="checkbox__label" for="gdpr">{{$t('contact.form.gdpr')}} <router-link target="_blank" to="/privacy">{{$t('privacy.title')}}</router-link></label>
                        </div>
                      <div class="checkbox">
                        <input type="checkbox" id="opt" v-model="formData.subscribe"><label class="checkbox__label" for="opt">{{$t('contact.form.optin')}}</label>
                      </div>
                        <button class="button" type="submit" form="contactform">{{$t('contact.form.send')}}</button>
                        <div class="contact__form__error">
                            <p v-for="item in errors" :key="`error--${item}`" class="error">
                                {{$t(`contact.form.error.${item}`)}}</p>
                            <p v-if="isError">{{$t('contact.form.mailerror')}}</p>
                        </div>
                        <p v-if="isSent" class="success">{{$t('contact.form.sent')}}</p>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UserService from "../services/user";

    export default {
        name: "Contact",

        data() {
            return {
                categories: ['info', 'reservation', 'activities', 'accommodation', 'environment', 'shuttle'],
                formData: {
                    name: "",
                    firstname: "",
                    subject: "reservation",
                    email: "",
                    tel: "",
                    message: "",
                    gdpr: false,
                    subscribe: 0
                },
                isSent: false,
                isError: false,
                errors: []
            };
        },

        methods: {
            checkForm() {
                this.errors = [];
                this.isSent = false;
                this.isError = false;
                const data = this.formData;

                if (!data.firstname) {
                    this.errors.push('firstname');
                }
                if (!data.name) {
                    this.errors.push('lastname');
                }
                if (!data.email) {
                    this.errors.push('email');
                } else if (!this.validateEmail(data.email)) {
                    this.errors.push('emailinvalid');
                }

                if (!data.message) {
                    this.errors.push('message');
                }

                if (!data.gdpr) {
                    this.errors.push('gdpr');
                }

                if (!this.errors.length) {
                    UserService.sendForm({
                        name: data.name,
                        firstname: data.firstname,
                        email: data.email,
                        text: data.message,
                        subject: data.subject,
                        subscribe:data.subscribe
                    })
                        .then((res) => {
                            if (res && res.status) {
                                this.clearForm();
                                this.isSent = true;
                            } else{
                                this.isError = true;
                            }
                        });
                }
            },

            validateEmail(email) {
                const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            clearForm() {
                this.formData = {
                    name: "",
                    firstname: "",
                    subject: "reservation",
                    email: "",
                    tel: "",
                    message: "",
                    gdpr: false,
                    subscribe: 0
                }
            }
        }
    }
</script>